import { useStyletron } from 'styletron-react';

type Props = {
  name: string;
  route: string;
  icon: string;
  isActive: boolean;
  clicked: (route: string) => void;
};
const SideDrawerItem = ({ name, route, icon, isActive, clicked }: Props) => {
  const [css] = useStyletron();

  const innerDivStyles = css({
    backgroundColor: isActive ? '#e5e5e5' : 'unset',
    padding: '15px 20px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: '10px',
    alignItems: 'center',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#e5e5e5',
    },
  });

  return (
    <div>
      <div className={innerDivStyles} onClick={() => clicked(route)}>
        <img
          className={css({ width: '25px', height: '25px' })}
          src={icon}
          alt="Sign in"
        />
        <span className={css({ marginLeft: '10px', fontWeight: 600 })}>
          {name}
        </span>
      </div>
    </div>
  );
};

export default SideDrawerItem;
